import { createSelector } from 'reselect'

// @ts-ignore
const getState = state => state.notifications

export const getNotifications = createSelector(
  getState,
  ({ notifications }) => notifications
)
